import React from "react";

import { Button } from "../ui/button";
import CustomChevronIcon, { Side } from "../ui/customChervonIcon";
import {
  DropdownMenu,
  DropdownMenuCheckboxItem,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from "../ui/dropdown-menu";

export interface ISelectProps {
  values: {
    key: string;
    value: string;
  }[];
  label?: string;
  selectedItems: string[];
  setSelectedItems: React.Dispatch<React.SetStateAction<string[]>>;
  side?: Side;
}

const MultiSelect: React.FC<ISelectProps> = ({
  selectedItems,
  setSelectedItems,
  values,
  label,
  side,
}) => {
  const handleSelectChange = (key: string): void => {
    if (selectedItems.includes(key)) {
      setSelectedItems((prev) => prev.filter((item) => item !== key));
    } else {
      setSelectedItems((prev) => [...prev, key]);
    }
  };

  const isOptionSelected = (key: string): boolean => {
    return selectedItems.includes(key);
  };

  // const _selectedValues = selectedItems.map((value) => {
  //   const selectedOption = values?.find((option) => option?.value === value)
  //   return selectedOption ? selectedOption.key : ""
  // })

  return (
    <>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button
            variant={side === "right" ? "default" : "outline"}
            className='flex justify-between gap-2 font-medium dashed-border'
          >
            <span className='overflow-x-hidden text-sm font-light'>
              {label || "Please Select Workspace"}
            </span>
            <CustomChevronIcon side={side} strokeWidth={1.5} />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent
          className='w-64'
          onCloseAutoFocus={(e) => e.preventDefault()}
          side={side}
        >
          {values?.map((value: ISelectProps["values"][0], index: number) => {
            return (
              <DropdownMenuCheckboxItem
                onSelect={(e) => e.preventDefault()}
                key={index}
                checked={isOptionSelected(value.value)}
                onCheckedChange={() => handleSelectChange(value.value)}
              >
                {value.key}
              </DropdownMenuCheckboxItem>
            );
          })}
        </DropdownMenuContent>
      </DropdownMenu>
    </>
  );
};

export default MultiSelect;
